import { Box } from 'styled-system/jsx';
import { TWalletProps } from '../../types/Wallet.types';

export default function WalletWrapperCard(props: TWalletProps) {
  const { children, wrapperProps, className } = props;

  return (
    <Box
      borderRadius="8px"
      padding="16px"
      className={className}
      {...wrapperProps}
    >
      {children}
    </Box>
  );
}
